import { COUNTRY_LANGUAGE_RECORD, type Language, MarketCountryCode } from '@ev-tech/search-modules-api';

export const getPrivateOfficeAdvisorFinderUrl = ({ language, placeId }: { language: Language; placeId?: string }): string => {
  const { languages, defaultLanguage } = COUNTRY_LANGUAGE_RECORD[MarketCountryCode['private-office']];
  const locale = languages.includes(language) ? language : defaultLanguage;
  const url = new URL(`https://www.engelvoelkers.com/private-office/${locale}/advisor-finder`);

  if (placeId) {
    url.searchParams.set('placeId', placeId);
  }

  return url.toString();
};
